import TimingManagerIcon from './component'

export default TimingManagerIcon